<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Recepción - OOTT {{ data.idOOTT }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
            class="form mt-8"
            [formGroup]="formObservaciones"
            autocomplete="off"
        >
            <mat-checkbox formControlName="tieneObservaciones"
                >Trabajo presenta observaciones</mat-checkbox
            >

            <mat-form-field class="full-width mt-8">
                <mat-label>Comentarios</mat-label>
                <textarea
                    matInput
                    formControlName="comentarios"
                    rows="3"
                    placeholder="Indique algún comentario sobre el trabajo realizado"
                ></textarea>
                <mat-hint
                    >{{ comentarios.value?.length }} /
                    {{ largoMaximo }}</mat-hint
                >

                <mat-error *ngIf="comentarios.hasError('minlength')">
                    Debe ingresar al menos
                    {{ comentarios.getError("minlength").requiredLength }}
                    caracteres
                </mat-error>
                <mat-error *ngIf="comentarios.hasError('maxlength')">
                    Máximo
                    {{ comentarios.getError("maxlength").requiredLength }}
                    caracteres
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formObservaciones.value"
            [disabled]="!formObservaciones.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
